
import { Box, Button, TextField, Typography, Link } from '@mui/material';
import { useForm } from '@inertiajs/react';
import { useState } from 'react';
import theme from './Theme';
import AuthLayout from './AuthLayout';

export default function ForgotPassword({ email: initialEmail = '' }) {
  const { data, setData, post, errors, submit } = useForm({ email: initialEmail });
  const [success, setSuccess] = useState(false);

  const handleForgotPassword = () => {
    submit('post', '/reset-password-request', {
      preserveScroll: true,
      onSuccess: () => {
        setSuccess(true);
      }
    });
  };

  return (
    <AuthLayout title="PrecisionRX | Forgot Password">
      <Typography variant="body1" sx={{ color: 'white', mt: {mobile: '0px', tablet_wide: '24px'} }}>
        Enter your email to receive a password reset link.
      </Typography>
      { success ? <Box sx={{ width: '100%' }}>
          <Typography variant="body1" color="success">Password reset email sent</Typography>
        </Box> : <Box component="form" sx={{ width: '100%' }}>
        <TextField
          margin="normal"
          required
          variant="outlined"
          fullWidth
          id="email"
          placeholder="Email address"
          name="email"
          autoComplete="email"
          autoFocus
          value={data.email}
          onChange={(e) => setData('email', e.target.value)}
          sx={{
            '& .MuiInputBase-root': { backgroundColor: 'white' },
          }}
        />

        {errors.email && <Typography variant="body2" color="error">Email not found</Typography>}

        <Box sx={{ display: 'flex', justifyContent: 'flex-starts', mt: 1, mb: 2 }}>
            <Link href={`/login`} variant="body2" sx={{ color: 'white' }}>
              Return to login
            </Link>
          </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          color="primary"
          sx={{ mt: 2,
            borderRadius: '4px',
            '&:disabled': { backgroundColor: theme.pandia.indigo_light }
          }}
          disabled={!data.email}
          onClick={handleForgotPassword}
        >
          Request password reset
          </Button>
        </Box>
      }
    </AuthLayout>
  );
}

